module.exports = __webpack_public_path__ + "static/media/Toren_Wachten.13367f99.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/05/02/assets/Toren_Wachten.mp3
// module id = 565
// module chunks = 0